import { createContext, Dispatch, SetStateAction } from 'react';

import {
  ConversionUnit,
  LocationType,
  SchemaBudgetType,
  StartEndReadingOption,
  StockBasedOption,
} from '@atom/types/schema';

export enum ModalStep {
  BASIC_DETAILS = 'BASIC_DETAILS',
  COST_TRACKING = 'COST_TRACKING',
  COST_AND_UNIT = 'COST_AND_UNIT',
}

export interface ModalStepType {
  title: string;
  value: ModalStep;
}

type Context = {
  activeStep: ModalStep;
  setActiveStep: Dispatch<SetStateAction<ModalStep>>;
  STEPS_ARRAY: ModalStepType[];
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  locationType: LocationType | null;
  setLocationType: Dispatch<SetStateAction<LocationType | null>>;
  colorId: number;
  setColorId: Dispatch<SetStateAction<number>>;
  markerId: number;
  setMarkerId: Dispatch<SetStateAction<number>>;
  isMaterial: boolean;
  setIsMaterial: Dispatch<SetStateAction<boolean>>;
  stockBasedOption: StockBasedOption;
  setStockBasedOption: Dispatch<SetStateAction<StockBasedOption>>;
  startEndReadingOption: StartEndReadingOption;
  setStartEndReadingOption: Dispatch<SetStateAction<StartEndReadingOption>>;
  costType: SchemaBudgetType;
  setCostType: Dispatch<SetStateAction<SchemaBudgetType>>;
  rate: number | null;
  setRate: Dispatch<SetStateAction<number | null>>;
  unit: string;
  setUnit: Dispatch<SetStateAction<string>>;
  conversionUnits: ConversionUnit[];
  setConversionUnits: Dispatch<SetStateAction<ConversionUnit[]>>;
  isEdit: boolean;
};

export const initialState: Context = {
  activeStep: ModalStep.BASIC_DETAILS,
  setActiveStep: () => {},
  STEPS_ARRAY: [],
  name: '',
  setName: () => {},
  locationType: null,
  setLocationType: () => {},
  colorId: 0,
  setColorId: () => {},
  markerId: 0,
  setMarkerId: () => {},
  isMaterial: false,
  setIsMaterial: () => {},
  stockBasedOption: StockBasedOption.NONE,
  setStockBasedOption: () => {},
  startEndReadingOption: StartEndReadingOption.NONE,
  setStartEndReadingOption: () => {},
  costType: SchemaBudgetType.VARIABLE,
  setCostType: () => {},
  rate: null,
  setRate: () => {},
  unit: '',
  setUnit: () => {},
  conversionUnits: [],
  setConversionUnits: () => {},
  isEdit: false,
};

const CreateEditSchemaModalContext = createContext<Context>(initialState);

export default CreateEditSchemaModalContext;
